
  <!-- Page Content -->
  <div  *ngIf="ShowPageContent" class="container-fluid">
    <!-- begin::Header -->
    <div class="card card-custom-h">
      <div class="card-header border-0 pt-5">
        <div class="card-title align-items-start flex-column" *ngIf="IsFilterLoaded">
          <form [formGroup]="WorkflowForm">
            <BBSF-TextBox [options]="searchTextBox" [group]="WorkflowForm"></BBSF-TextBox>
          </form>
        </div>
        <div class="card-toolbar">
          <!-- begin::Menu -->
          <button type="button" class="btn btn-sm btn-primary" (click)="showAddWorkflowModal(AddWorkflowModal)">
            <i class="fas fa-plus me-1"></i>
            {{utilityService.getResourceValue("Add")}}
          </button>
          <!-- end::Menu -->
        </div>
      </div>
      <!-- end::Header -->
      <!-- begin::Body -->
      <div class="card-body py-3">
        <table class="table align-middle table-row-dashed fs-6 gy-5 dataTable no-footer">
          <thead>
            <tr class="text-start text-gray-400 fw-bolder fs-7 text-uppercase gs-0">
              <th class="min-w-150px">{{utilityService.getResourceValue("Name")}}</th>
              <th class="min-w-250px">{{utilityService.getResourceValue("Description")}}</th>
              <th class="min-w-150px" *ngIf="!ProductionMode">{{utilityService.getResourceValue("SysName")}}</th>
              <th class="min-w-50px">{{utilityService.getResourceValue("Action")}}</th>
            </tr>
          </thead>
          <tbody id="listingContainer" class="fw-bold text-gray-600 border-0">
            <tr *ngFor="let Workflow of WorkflowPagingResult">
              <td>
                <a *ngIf="language=='en'" href="javascript:void(0)" [routerLink]="['/Admin/Workflows/tabs',Workflow.id,Workflow.workflowVersionID]" routerLinkActive="router-link-active"
                   class="text-gray-800 text-hover-primary">{{Workflow.name.english}}</a>
                <a *ngIf="language=='ar'" href="javascript:void(0)" [routerLink]="['/Admin/Workflows/tabs',Workflow.id,Workflow.workflowVersionID]" routerLinkActive="router-link-active"
                   class="text-gray-800 text-hover-primary">{{Workflow.name.arabic}}</a>
              </td>
              <td *ngIf="language=='en'">{{Workflow.description.english}}</td>
              <td *ngIf="language=='ar'">{{Workflow.description.arabic}}</td>

              <td *ngIf="!ProductionMode">{{Workflow.sysName}}</td>
              <td>
                <div>
                  <button mat-button [matMenuTriggerFor]="menu" class="btn btn-sm btn-icon btn-light btn-active-light-primary">
                    <i class="fa fa-ellipsis-h" aria-hidden="true"></i>
                  </button>
                  <mat-menu #menu="matMenu">
                    <button class="drop-item px-3" ngbDropdownItem
                            (click)="showEditWorkflowModal(Workflow, EditWorkflowModal)">
                      <span class="drop-link px-3">{{utilityService.getResourceValue("Edit")}}</span>
                    </button>
                  </mat-menu>
                </div>
              </td>
            </tr>
            <tr *ngIf="WorkflowPagingResult.length == 0">
              <td [attr.colspan]="ProductionMode ? '3' : '4'">
                <lib-empty-data></lib-empty-data>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="card-footer border-0">
        <BBSF-Paging (Items)="setWorkflowListResult($event)" *ngIf="IsFilterLoaded"
                     [options]="WorkflowPaging" [group]="WorkflowForm" #WorkflowPagingViewElement>
        </BBSF-Paging>
      </div>

    </div>
  </div>


  <!-- Add Modal -->
  <ng-template #AddWorkflowModal let-modal>
    <div class="modal-header pb-0 border-0 justify-content-end">
      <h5 class="modal-title" id="exampleModalLabel"></h5>
      <button type="button" data-dismiss="modal" aria-label="Close" class="btn btn-sm btn-icon btn-active-color-primary" (click)="modal.dismiss()">
        <span class="svg-icon svg-icon-1">
          <span [inlineSVG]="'./src/assets/images/arr061.svg'"></span>
        </span>
      </button>
    </div>
    <div class="modal-body scroll-y px-10 px-lg-15 pt-0 pb-15">
      <div class="mb-13 text-center">
        <h1 class="mb-3">{{utilityService.getResourceValue("Add")}} {{utilityService.getResourceValue("Workflow")}}</h1>
      </div>

      <form [formGroup]="AddWorkflowForm"
            (ngSubmit)="addWorkflow()">
        <div class="row">
          <div class="col-md-12">
            <BBSF-TextBox [options]="NameInEnglish" [group]="AddWorkflowForm">
            </BBSF-TextBox>
          </div>

        </div>
        <div class="row">
          <div class="col-md-12">
            <BBSF-TextBox [options]="NameInArabic" [group]="AddWorkflowForm">
            </BBSF-TextBox>
          </div>

        </div>
        <div class="row">
          <div class="col-md-12">
            <BBSF-TextBox [options]="DescriptionInEnglish" [group]="AddWorkflowForm">
            </BBSF-TextBox>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <BBSF-TextBox [options]="DescriptionInArabic" [group]="AddWorkflowForm">
            </BBSF-TextBox>
          </div>
        </div>
        <div class="row" *ngIf="!ProductionMode">
          <div class="col-md-12">
            <BBSF-TextBox [options]="SysName" [group]="AddWorkflowForm">
            </BBSF-TextBox>
          </div>
        </div>
        <div class="text-center pt-7">
          <button #CloseWorkflowModal id="CloseWorkflowModal" type="button" class="btn btn-light me-3 btn-sm"
                  (click)="modal.dismiss()">
            {{utilityService.getResourceValue("CancelLabel")}}
          </button>
          <button type="submit" class="btn btn-primary btn-sm">{{utilityService.getResourceValue("SaveLabel")}}</button>
        </div>
      </form>
    </div>
  </ng-template>


  <!--Edit Modal-->
  <ng-template #EditWorkflowModal let-modal>
    <div class="modal-header pb-0 border-0 justify-content-end">
      <h5 class="modal-title" id="exampleModalLabel"></h5>
      <button type="button" data-dismiss="modal" aria-label="Close" class="btn btn-sm btn-icon btn-active-color-primary" (click)="modal.dismiss()">
        <span class="svg-icon svg-icon-1">
          <span [inlineSVG]="'./src/assets/images/arr061.svg'"></span>
        </span>
      </button>
    </div>
    <div class="modal-body scroll-y px-10 px-lg-15 pt-0 pb-15">
      <div class="mb-13 text-center">
        <h1 class="mb-3">{{utilityService.getResourceValue("Edit")}} {{utilityService.getResourceValue("Workflow")}}</h1>
      </div>
      <form [formGroup]="EditWorkflowForm" (ngSubmit)="editWorkflow()">
        <div class="row">
          <div class="col-md-12">
            <BBSF-TextBox [options]="EditNameInEnglish" [group]="EditWorkflowForm">
            </BBSF-TextBox>
          </div>

        </div>
        <div class="row">
          <div class="col-md-12">
            <BBSF-TextBox [options]="EditNameInArabic" [group]="EditWorkflowForm">
            </BBSF-TextBox>
          </div>

        </div>
        <div class="row">
          <div class="col-md-12">
            <BBSF-TextBox [options]="EditDescriptionInEnglish" [group]="EditWorkflowForm">
            </BBSF-TextBox>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <BBSF-TextBox [options]="EditDescriptionInArabic" [group]="EditWorkflowForm">
            </BBSF-TextBox>
          </div>
        </div>
        <div class="row" *ngIf="!ProductionMode">
          <div class="col-md-12">
            <BBSF-TextBox [options]="EditSysName" [group]="EditWorkflowForm">
            </BBSF-TextBox>
          </div>
        </div>
        <div class="text-center pt-7">
          <button #CloseEditWorkflowModal id="CloseEditWorkflowModal" type="button"
                  class="btn btn-light btn-sm  me-3" data-dismiss="modal" (click)="modal.dismiss()">
            {{utilityService.getResourceValue("CancelLabel")}}
          </button>
          <button type="submit" class="btn btn-primary btn-sm">{{utilityService.getResourceValue("SaveLabel")}}</button>
        </div>
      </form>
    </div>
  </ng-template>

